export type Message_ID = string | number

export type MessageType = 'ad' | 'info'

export type MessageAction =
  | 'all'
  | 'employeesInside'
  | 'employeesOutside'
  | 'authorizedInside'
  | 'authorizedOutside'
  | 'personal'
  | 'parents'
  | 'employees' /*| 'inside'  | 'arrived' | 'hasNotArrived' | 'arrivingToday' | 'arrivesAtDate' | 'left' */

export type Display_Type = 'push' | 'onScreen'

export type Target = 'auth_present' | 'auth_absent' | 'emp_present' | 'emp_absent' | 'employees' | 'authorized' | 'self' | 'inviter' | 'related'

export type Initiator = 'employees' | 'authorized' | 'invited' | 'cportal_user'

export type Trigger =
  | 'enter'
  | 'exit'
  | 'open_once'
  | 'unauthentic'
  | 'keep_open'
  | 'open_once_app'
  | 'station_disconnect'
  | 'cportal_login_success'
  | 'cportal_login_outside_hours'
  /** YB-2150/2153 still inside after the stay, today's hours or the pass ended. Keyera only, alone, recipients self / inviter / target_ids. */
  | 'overtime'

export class Message {
  id: Message_ID
  type: MessageType = 'ad'
  subject: string = ''
  action: MessageAction = 'all'
  event_id: number = NaN
  body: string = ''
  time: string = ''
  user_image: string = ''
  user_full_name: string = ''
  display_type: Display_Type = 'push'
}

export class PushMessageEventInput {
  event_id: number = NaN
  body: string = ''
  subject: string = ''
  type: MessageType = 'ad'
  action: MessageAction = 'all'
  display_type: Display_Type = 'push'
  personal_ids?: number[] = []
  arrival_date?: string = ''
}

export class RuleBasedNotificationsDetails {
  target?: Target[] | null = null
  initiator: Initiator[] | null = null
  trigger?: Trigger[] | null = null
}

export class CreateRuleNotificationInput extends RuleBasedNotificationsDetails {
  client_id: number = NaN
  platform: 'gaterix' | 'keyera' = 'gaterix'
  event_id?: number | null = null
  areas?: number[] | null = null
  title: string | null = null
  body: string | null = null
  target_ids?: number | null = null
  /** YB-2156 — client roles whose active members receive the push (Keyera only) */
  target_client_role_ids?: string[] | null = null
  trigger_user_ids?: number[] | null = null
}

export class UpdateRuleNotificationInput extends CreateRuleNotificationInput {
  id: number | null = null
  active?: boolean | null = null
}
